import moment from 'moment'
import 'moment/locale/ru'
import { VueConstructor } from 'vue/types/umd'

const DEFAULT_LOCALE = 'ru'
const DEFAULT_FORMAT = 'D MMM Y, HH:mm'
const DEFAULT_INVALID_DATE = 'Отсутствует'

const MomentPlugin = {
  install(Vue: VueConstructor) {
    moment.locale(DEFAULT_LOCALE)
    moment.defaultFormat = DEFAULT_FORMAT
    moment.updateLocale(moment.locale(), { invalidDate: DEFAULT_INVALID_DATE })
    Vue.prototype.$moment = moment

    Vue.filter('moment', value => {
      if (value == null) {
        return
      }

      return moment(value).format()
    })
  },
}

export { MomentPlugin }
